import { render } from "./SubClients.vue?vue&type=template&id=0f70dfa0"
import script from "./SubClients.vue?vue&type=script&lang=js"
export * from "./SubClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__